<div><label class="info-label">{{title}}</label></div>
<fieldset [attr.aria-label]="title">
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="formFactorIsSelected(chromebaseLabel)"
      (change)="onFormFactorChange(chromebaseLabel)"
      (keyup.enter)="onFormFactorChange(chromebaseLabel)"
      *ngIf="chromebaseLabel !== ''">
      <span class="filter-label">{{chromebaseLabel}}</span>
    </mat-checkbox>
    <div class="spacer-xx-small"></div>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="formFactorIsSelected(chromeboxLabel)"
      (change)="onFormFactorChange(chromeboxLabel)"
      (keyup.enter)="onFormFactorChange(chromeboxLabel)"
      *ngIf="chromeboxLabel !== ''">
      <span class="filter-label">{{chromeboxLabel}}</span>
    </mat-checkbox>
    <div class="spacer-xx-small"></div>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="formFactorIsSelected(clamshellLabel)"
      (change)="onFormFactorChange(clamshellLabel)"
      (keyup.enter)="onFormFactorChange(clamshellLabel)"
      *ngIf="clamshellLabel !==''">
      <span class="filter-label">{{clamshellLabel}}</span>
    </mat-checkbox>
    <div class="spacer-xx-small"></div>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="formFactorIsSelected(convertibleLabel)"
      (change)="onFormFactorChange(convertibleLabel)"
      (keyup.enter)="onFormFactorChange(convertibleLabel)"
      *ngIf="convertibleLabel !== ''">
      <span class="filter-label">{{convertibleLabel}}</span>
    </mat-checkbox>
    <div class="spacer-xx-small"></div>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="formFactorIsSelected(tabletLabel)"
      (change)="onFormFactorChange(tabletLabel)"
      (keyup.enter)="onFormFactorChange(tabletLabel)"
      *ngIf="tabletLabel !== ''">
      <span class="filter-label">{{tabletLabel}}</span>
    </mat-checkbox>
    <div class="spacer-xx-small"></div>
  </div>
</fieldset>
